import { SportsJackpotBannerViewModel } from '@frontend/sports/types/components/banners/models';
import { TeaserViewModel } from '@frontend/sports/types/components/teasers';

export interface EnhancedTeaserViewModel extends TeaserViewModel {
    details?: any;
    extract?: boolean;
    jackpotBanner?: SportsJackpotBannerViewModel;
    options?: string[];
    originalTeasersCount?: number;
    showMore?: boolean;
    visibleTeaser?: boolean;
}

export interface TeasersResponse {
    teasers: EnhancedTeaserViewModel[];
}

export enum Alignment {
    Right = 'Right',
    Left = 'Left',
    Center = 'Center',
}
